define(function() {
	var Backbone = require('backbone');
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/portal/ui',
		url: function() {
			var url = this.urlRoot;

			if (this.portlet) {
				if (this.portlet == 'myprojects' || this.portlet == 'lookup' || this.portlet =='instrumentdetails') {
					url +='/instrumentSetup/' + this.portlet;
				} else if (this.portlet == 'myassignments' || this.portlet == 'mytask') {
					url += '/assignmentsetups'
				} 
			}

			if (this.instrumentType) {
				url += '/' + this.instrumentType;
			}
			
			if (this.portlet == 'mytask') {
				url += '?view=mytask'
			}

			return url;
		},
		parse: function(response) {
			//TEMPORARY CODE TO REMOVE FEES FROM LOOKUP CONFIG
			//This should be done in the RS. See ticket HPS-106989
			if(this.portlet.toLowerCase() == 'lookup'){
				this.removeProp(response.data, 'fees');
			}
			this.responseStatus = response.responseStatus;
			if(this.portlet.toLowerCase()=='myprojects'){
				response.data.portalInstrument = {
					fields:{
						myprojects:{
							summary:[
								'applicationName'
							],
							status:[
								'status',
								'addedDate'
							]
						}
					}
				};
				response.data.portalScenario = {
					fields:{
						myprojects:{
							summary:[
								'applicationName'
							],
							status:[
								'status',
								'addedDate'
							]
						}
					}

				};
				response.data.requiredRecord = {
					fields:{
						myprojects:{
							summary:[
								'applicationName'
							],
							details:[
								'status',
								'description'
							]
						}
					}

				};
			}
			return this.removeProp(response.data, '__type');
		},
		//end backbone functions//

		//hopefully temporary code to remove the __type variable and fees object in lookup.
		removeProp: function(obj, propToDelete) {
			for (var property in obj) {
				if (property === propToDelete) {
						delete obj[property];
				} else if (typeof obj[property] == 'object') {
					let objectToCheck = obj[property];
					delete obj.property;
					let newJsonData = this.removeProp(obj[property], propToDelete);
					obj[property] = newJsonData;
				}
			}
			return obj;
		}
	});
});
